import { inject as H, ref as k, onUnmounted as fe, reactive as Se, toRefs as we, onMounted as xe, nextTick as de, readonly as he, watch as Y, getCurrentInstance as Ee, toRef as Te, customRef as Ie, getCurrentScope as Re, onScopeDispose as Oe, shallowRef as ke, computed as W, toValue as A, unref as Z, defineComponent as Ae, renderSlot as V } from "vue";
var ee = function(t, n) {
  return ee = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, r) {
    e.__proto__ = r;
  } || function(e, r) {
    for (var o in r)
      Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
  }, ee(t, n);
}, g = function() {
  return g = Object.assign || function(t) {
    for (var n, e = 1, r = arguments.length; e < r; e++)
      for (var o in n = arguments[e])
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    return t;
  }, g.apply(this, arguments);
};
function w(t, n, e, r) {
  return new (e || (e = Promise))(function(o, i) {
    function s(c) {
      try {
        u(r.next(c));
      } catch (l) {
        i(l);
      }
    }
    function a(c) {
      try {
        u(r.throw(c));
      } catch (l) {
        i(l);
      }
    }
    function u(c) {
      var l;
      c.done ? o(c.value) : (l = c.value, l instanceof e ? l : new e(function(v) {
        v(l);
      })).then(s, a);
    }
    u((r = r.apply(t, [])).next());
  });
}
function x(t, n) {
  var e, r, o, i = { label: 0, sent: function() {
    if (1 & o[0])
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, s = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return s.next = a(0), s.throw = a(1), s.return = a(2), typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function a(u) {
    return function(c) {
      return function(l) {
        if (e)
          throw new TypeError("Generator is already executing.");
        for (; s && (s = 0, l[0] && (i = 0)), i; )
          try {
            if (e = 1, r && (o = 2 & l[0] ? r.return : l[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, l[1])).done)
              return o;
            switch (r = 0, o && (l = [2 & l[0], o.value]), l[0]) {
              case 0:
              case 1:
                o = l;
                break;
              case 4:
                return i.label++, { value: l[1], done: !1 };
              case 5:
                i.label++, r = l[1], l = [0];
                continue;
              case 7:
                l = i.ops.pop(), i.trys.pop();
                continue;
              default:
                if (o = i.trys, !((o = o.length > 0 && o[o.length - 1]) || l[0] !== 6 && l[0] !== 2)) {
                  i = 0;
                  continue;
                }
                if (l[0] === 3 && (!o || l[1] > o[0] && l[1] < o[3])) {
                  i.label = l[1];
                  break;
                }
                if (l[0] === 6 && i.label < o[1]) {
                  i.label = o[1], o = l;
                  break;
                }
                if (o && i.label < o[2]) {
                  i.label = o[2], i.ops.push(l);
                  break;
                }
                o[2] && i.ops.pop(), i.trys.pop();
                continue;
            }
            l = n.call(t, i);
          } catch (v) {
            l = [6, v], r = 0;
          } finally {
            e = o = 0;
          }
        if (5 & l[0])
          throw l[1];
        return { value: l[0] ? l[1] : void 0, done: !0 };
      }([u, c]);
    };
  }
}
var pe = { exports: {} };
function te() {
}
te.prototype = { on: function(t, n, e) {
  var r = this.e || (this.e = {});
  return (r[t] || (r[t] = [])).push({ fn: n, ctx: e }), this;
}, once: function(t, n, e) {
  var r = this;
  function o() {
    r.off(t, o), n.apply(e, arguments);
  }
  return o._ = n, this.on(t, o, e);
}, emit: function(t) {
  for (var n = [].slice.call(arguments, 1), e = ((this.e || (this.e = {}))[t] || []).slice(), r = 0, o = e.length; r < o; r++)
    e[r].fn.apply(e[r].ctx, n);
  return this;
}, off: function(t, n) {
  var e = this.e || (this.e = {}), r = e[t], o = [];
  if (r && n)
    for (var i = 0, s = r.length; i < s; i++)
      r[i].fn !== n && r[i].fn._ !== n && o.push(r[i]);
  return o.length ? e[t] = o : delete e[t], this;
} }, pe.exports = te;
var Ne = pe.exports.TinyEmitter = te, z = function(t) {
  var n = t[1];
  return n != null;
}, Ce = function(t) {
  var n = t.properties, e = n === void 0 ? {} : n, r = function(i, s) {
    var a = {};
    for (var u in i)
      Object.prototype.hasOwnProperty.call(i, u) && s.indexOf(u) < 0 && (a[u] = i[u]);
    if (i != null && typeof Object.getOwnPropertySymbols == "function") {
      var c = 0;
      for (u = Object.getOwnPropertySymbols(i); c < u.length; c++)
        s.indexOf(u[c]) < 0 && Object.prototype.propertyIsEnumerable.call(i, u[c]) && (a[u[c]] = i[u[c]]);
    }
    return a;
  }(t, ["properties"]), o = function(i) {
    return Object.entries(i).sort(function(s, a) {
      var u = s[0], c = a[0];
      return u.localeCompare(c, void 0);
    });
  };
  return JSON.stringify([o(r), o(e)]);
}, ie = function(t) {
  return w(void 0, void 0, void 0, function() {
    var n;
    return x(this, function(e) {
      switch (e.label) {
        case 0:
          n = Ce(t), e.label = 1;
        case 1:
          return e.trys.push([1, 3, , 4]), [4, (r = n, w(void 0, void 0, void 0, function() {
            var o, i, s, a, u;
            return x(this, function(c) {
              switch (c.label) {
                case 0:
                  if (o = typeof globalThis < "u" && (!((a = globalThis.crypto) === null || a === void 0) && a.subtle) ? (u = globalThis.crypto) === null || u === void 0 ? void 0 : u.subtle : void 0, typeof TextEncoder > "u" || !(o != null && o.digest) || typeof Uint8Array > "u")
                    throw new Error("Hashing function not available");
                  return i = new TextEncoder().encode(r), [4, o.digest("SHA-256", i)];
                case 1:
                  return s = c.sent(), [2, Array.from(new Uint8Array(s)).map(function(l) {
                    return l.toString(16).padStart(2, "0");
                  }).join("")];
              }
            });
          }))];
        case 2:
          return [2, e.sent()];
        case 3:
          return e.sent(), [2, n];
        case 4:
          return [2];
      }
      var r;
    });
  });
}, ve = "unleash-js@3.7.2", Ue = function() {
}, je = function() {
  function t(n) {
    var e = n.onError, r = n.onSent, o = n.appName, i = n.metricsInterval, s = n.disableMetrics, a = s !== void 0 && s, u = n.url, c = n.clientKey, l = n.fetch, v = n.headerName, E = n.customHeaders, I = E === void 0 ? {} : E, S = n.metricsIntervalInitial, h = n.connectionId;
    this.onError = e, this.onSent = r || Ue, this.disabled = a, this.metricsInterval = 1e3 * i, this.metricsIntervalInitial = 1e3 * S, this.appName = o, this.url = u instanceof URL ? u : new URL(u), this.clientKey = c, this.bucket = this.createEmptyBucket(), this.fetch = l, this.headerName = v, this.customHeaders = I, this.connectionId = h;
  }
  return t.prototype.start = function() {
    var n = this;
    if (this.disabled)
      return !1;
    typeof this.metricsInterval == "number" && this.metricsInterval > 0 && (this.metricsIntervalInitial > 0 ? setTimeout(function() {
      n.startTimer(), n.sendMetrics();
    }, this.metricsIntervalInitial) : this.startTimer());
  }, t.prototype.stop = function() {
    this.timer && (clearTimeout(this.timer), delete this.timer);
  }, t.prototype.createEmptyBucket = function() {
    return { start: /* @__PURE__ */ new Date(), stop: null, toggles: {} };
  }, t.prototype.getHeaders = function() {
    var n, e = ((n = {})[this.headerName] = this.clientKey, n.Accept = "application/json", n["Content-Type"] = "application/json", n["x-unleash-sdk"] = ve, n["x-unleash-connection-id"] = this.connectionId, n["x-unleash-appname"] = this.appName, n);
    return Object.entries(this.customHeaders).filter(z).forEach(function(r) {
      var o = r[0], i = r[1];
      return e[o] = i;
    }), e;
  }, t.prototype.sendMetrics = function() {
    return w(this, void 0, void 0, function() {
      var n, e, r;
      return x(this, function(o) {
        switch (o.label) {
          case 0:
            if (n = "".concat(this.url, "/client/metrics"), e = this.getPayload(), this.bucketIsEmpty(e))
              return [2];
            o.label = 1;
          case 1:
            return o.trys.push([1, 3, , 4]), [4, this.fetch(n, { cache: "no-cache", method: "POST", headers: this.getHeaders(), body: JSON.stringify(e) })];
          case 2:
            return o.sent(), this.onSent(e), [3, 4];
          case 3:
            return r = o.sent(), console.error("Unleash: unable to send feature metrics", r), this.onError(r), [3, 4];
          case 4:
            return [2];
        }
      });
    });
  }, t.prototype.count = function(n, e) {
    return !(this.disabled || !this.bucket) && (this.assertBucket(n), this.bucket.toggles[n][e ? "yes" : "no"]++, !0);
  }, t.prototype.countVariant = function(n, e) {
    return !(this.disabled || !this.bucket) && (this.assertBucket(n), this.bucket.toggles[n].variants[e] ? this.bucket.toggles[n].variants[e] += 1 : this.bucket.toggles[n].variants[e] = 1, !0);
  }, t.prototype.assertBucket = function(n) {
    if (this.disabled || !this.bucket)
      return !1;
    this.bucket.toggles[n] || (this.bucket.toggles[n] = { yes: 0, no: 0, variants: {} });
  }, t.prototype.startTimer = function() {
    var n = this;
    this.timer = setInterval(function() {
      n.sendMetrics();
    }, this.metricsInterval);
  }, t.prototype.bucketIsEmpty = function(n) {
    return Object.keys(n.bucket.toggles).length === 0;
  }, t.prototype.getPayload = function() {
    var n = g(g({}, this.bucket), { stop: /* @__PURE__ */ new Date() });
    return this.bucket = this.createEmptyBucket(), { bucket: n, appName: this.appName, instanceId: "browser" };
  }, t;
}(), De = function() {
  function t() {
    this.store = /* @__PURE__ */ new Map();
  }
  return t.prototype.save = function(n, e) {
    return w(this, void 0, void 0, function() {
      return x(this, function(r) {
        return this.store.set(n, e), [2];
      });
    });
  }, t.prototype.get = function(n) {
    return w(this, void 0, void 0, function() {
      return x(this, function(e) {
        return [2, this.store.get(n)];
      });
    });
  }, t;
}(), _e = function() {
  function t(n) {
    n === void 0 && (n = "unleash:repository"), this.prefix = n;
  }
  return t.prototype.save = function(n, e) {
    return w(this, void 0, void 0, function() {
      var r, o;
      return x(this, function(i) {
        r = JSON.stringify(e), o = "".concat(this.prefix, ":").concat(n);
        try {
          window.localStorage.setItem(o, r);
        } catch (s) {
          console.error(s);
        }
        return [2];
      });
    });
  }, t.prototype.get = function(n) {
    try {
      var e = "".concat(this.prefix, ":").concat(n), r = window.localStorage.getItem(e);
      return r ? JSON.parse(r) : void 0;
    } catch (o) {
      console.error(o);
    }
  }, t;
}();
let K;
const Fe = new Uint8Array(16);
function Pe() {
  if (!K && (K = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !K))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return K(Fe);
}
const b = [];
for (let t = 0; t < 256; ++t)
  b.push((t + 256).toString(16).slice(1));
var se = { randomUUID: typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto) };
function Le(t, n, e) {
  if (se.randomUUID && !t)
    return se.randomUUID();
  const r = (t = t || {}).random || (t.rng || Pe)();
  return r[6] = 15 & r[6] | 64, r[8] = 63 & r[8] | 128, function(o, i = 0) {
    return b[o[i + 0]] + b[o[i + 1]] + b[o[i + 2]] + b[o[i + 3]] + "-" + b[o[i + 4]] + b[o[i + 5]] + "-" + b[o[i + 6]] + b[o[i + 7]] + "-" + b[o[i + 8]] + b[o[i + 9]] + "-" + b[o[i + 10]] + b[o[i + 11]] + b[o[i + 12]] + b[o[i + 13]] + b[o[i + 14]] + b[o[i + 15]];
  }(r);
}
var Me = function() {
  function t() {
  }
  return t.prototype.generateEventId = function() {
    return Le();
  }, t.prototype.createImpressionEvent = function(n, e, r, o, i, s) {
    var a = this.createBaseEvent(n, e, r, o, i);
    return s ? g(g({}, a), { variant: s }) : a;
  }, t.prototype.createBaseEvent = function(n, e, r, o, i) {
    return { eventType: o, eventId: this.generateEventId(), context: n, enabled: e, featureName: r, impressionData: i };
  }, t;
}(), He = ["userId", "sessionId", "remoteAddress", "currentTime"], ae = function(t) {
  return He.includes(t);
}, R = { INIT: "initialized", ERROR: "error", READY: "ready", UPDATE: "update", IMPRESSION: "impression", SENT: "sent", RECOVERED: "recovered" }, Je = "isEnabled", Ke = "getVariant", qe = { name: "disabled", enabled: !1, feature_enabled: !1 }, Q = "repo", le = "repoLastUpdateTimestamp", Be = function() {
  try {
    if (typeof window < "u" && "fetch" in window)
      return fetch.bind(window);
    if ("fetch" in globalThis)
      return fetch.bind(globalThis);
  } catch (t) {
    console.error('Unleash failed to resolve "fetch"', t);
  }
}, ze = function(t) {
  function n(e) {
    var r = e.storageProvider, o = e.url, i = e.clientKey, s = e.disableRefresh, a = s !== void 0 && s, u = e.refreshInterval, c = u === void 0 ? 30 : u, l = e.metricsInterval, v = l === void 0 ? 30 : l, E = e.metricsIntervalInitial, I = E === void 0 ? 2 : E, S = e.disableMetrics, h = S !== void 0 && S, p = e.appName, m = e.environment, U = m === void 0 ? "default" : m, O = e.context, j = e.fetch, D = j === void 0 ? Be() : j, M = e.createAbortController, J = M === void 0 ? function() {
      try {
        if (typeof window < "u" && "AbortController" in window)
          return function() {
            return new window.AbortController();
          };
        if ("fetch" in globalThis)
          return function() {
            return new globalThis.AbortController();
          };
      } catch (F) {
        console.error('Unleash failed to resolve "AbortController" factory', F);
      }
    }() : M, N = e.bootstrap, C = e.bootstrapOverride, G = C === void 0 || C, d = e.headerName, y = d === void 0 ? "Authorization" : d, T = e.customHeaders, ne = T === void 0 ? {} : T, re = e.impressionDataAll, me = re !== void 0 && re, oe = e.usePOSTrequests, be = oe !== void 0 && oe, _ = e.experimental, f = t.call(this) || this;
    if (f.toggles = [], f.etag = "", f.readyEventEmitted = !1, f.fetchedFromServer = !1, f.usePOSTrequests = !1, f.started = !1, !o)
      throw new Error("url is required");
    if (!i)
      throw new Error("clientKey is required");
    if (!p)
      throw new Error("appName is required.");
    return f.eventsHandler = new Me(), f.impressionDataAll = me, f.toggles = N && N.length > 0 ? N : [], f.url = o instanceof URL ? o : new URL(o), f.clientKey = i, f.headerName = y, f.customHeaders = ne, f.storage = r || (typeof window < "u" ? new _e() : new De()), f.refreshInterval = a ? 0 : 1e3 * c, f.context = g({ appName: p, environment: U }, O), f.usePOSTrequests = be, f.sdkState = "initializing", f.experimental = g({}, _), _ != null && _.togglesStorageTTL && (_ == null ? void 0 : _.togglesStorageTTL) > 0 && (f.experimental.togglesStorageTTL = 1e3 * _.togglesStorageTTL), f.lastRefreshTimestamp = 0, f.ready = new Promise(function(F) {
      f.init().then(F).catch(function(P) {
        console.error(P), f.sdkState = "error", f.emit(R.ERROR, P), f.lastError = P, F();
      });
    }), D || console.error('Unleash: You must either provide your own "fetch" implementation or run in an environment where "fetch" is available.'), J || console.error('Unleash: You must either provide your own "AbortController" implementation or run in an environment where "AbortController" is available.'), f.fetch = D, f.createAbortController = J, f.bootstrap = N && N.length > 0 ? N : void 0, f.bootstrapOverride = G, f.connectionId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(F) {
      var P = 16 * Math.random() | 0;
      return (F === "x" ? P : 3 & P | 8).toString(16);
    }), f.metrics = new je({ onError: f.emit.bind(f, R.ERROR), onSent: f.emit.bind(f, R.SENT), appName: p, metricsInterval: v, disableMetrics: h, url: f.url, clientKey: i, fetch: D, headerName: y, customHeaders: ne, metricsIntervalInitial: I, connectionId: f.connectionId }), f;
  }
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    function o() {
      this.constructor = e;
    }
    ee(e, r), e.prototype = r === null ? Object.create(r) : (o.prototype = r.prototype, new o());
  }(n, t), n.prototype.getAllToggles = function() {
    return function(e, r, o) {
      for (var i, s = 0, a = r.length; s < a; s++)
        !i && s in r || (i || (i = Array.prototype.slice.call(r, 0, s)), i[s] = r[s]);
      return e.concat(i || Array.prototype.slice.call(r));
    }([], this.toggles);
  }, n.prototype.isEnabled = function(e) {
    var r, o = this.toggles.find(function(a) {
      return a.name === e;
    }), i = !!o && o.enabled;
    if (this.metrics.count(e, i), (o == null ? void 0 : o.impressionData) || this.impressionDataAll) {
      var s = this.eventsHandler.createImpressionEvent(this.context, i, e, Je, (r = o == null ? void 0 : o.impressionData) !== null && r !== void 0 ? r : void 0);
      this.emit(R.IMPRESSION, s);
    }
    return i;
  }, n.prototype.getVariant = function(e) {
    var r, o = this.toggles.find(function(u) {
      return u.name === e;
    }), i = (o == null ? void 0 : o.enabled) || !1, s = o ? o.variant : qe;
    if (s.name && this.metrics.countVariant(e, s.name), this.metrics.count(e, i), (o == null ? void 0 : o.impressionData) || this.impressionDataAll) {
      var a = this.eventsHandler.createImpressionEvent(this.context, i, e, Ke, (r = o == null ? void 0 : o.impressionData) !== null && r !== void 0 ? r : void 0, s.name);
      this.emit(R.IMPRESSION, a);
    }
    return g(g({}, s), { feature_enabled: i });
  }, n.prototype.updateToggles = function() {
    return w(this, void 0, void 0, function() {
      var e = this;
      return x(this, function(r) {
        switch (r.label) {
          case 0:
            return this.timerRef || this.fetchedFromServer ? [4, this.fetchToggles()] : [3, 2];
          case 1:
            return r.sent(), [3, 4];
          case 2:
            return this.started ? [4, new Promise(function(o) {
              var i = function() {
                e.fetchToggles().then(function() {
                  e.off(R.READY, i), o();
                });
              };
              e.once(R.READY, i);
            })] : [3, 4];
          case 3:
            r.sent(), r.label = 4;
          case 4:
            return [2];
        }
      });
    });
  }, n.prototype.updateContext = function(e) {
    return w(this, void 0, void 0, function() {
      var r;
      return x(this, function(o) {
        switch (o.label) {
          case 0:
            return (e.appName || e.environment) && console.warn("appName and environment are static. They can't be updated with updateContext."), r = { environment: this.context.environment, appName: this.context.appName, sessionId: this.context.sessionId }, this.context = g(g({}, r), e), [4, this.updateToggles()];
          case 1:
            return o.sent(), [2];
        }
      });
    });
  }, n.prototype.getContext = function() {
    return g({}, this.context);
  }, n.prototype.setContextField = function(e, r) {
    var o, i;
    if (ae(e))
      this.context = g(g({}, this.context), ((o = {})[e] = r, o));
    else {
      var s = g(g({}, this.context.properties), ((i = {})[e] = r, i));
      this.context = g(g({}, this.context), { properties: s });
    }
    this.updateToggles();
  }, n.prototype.removeContextField = function(e) {
    var r;
    ae(e) ? this.context = g(g({}, this.context), ((r = {})[e] = void 0, r)) : typeof this.context.properties == "object" && delete this.context.properties[e], this.updateToggles();
  }, n.prototype.setReady = function() {
    this.readyEventEmitted = !0, this.emit(R.READY);
  }, n.prototype.init = function() {
    return w(this, void 0, void 0, function() {
      var e, r, o;
      return x(this, function(i) {
        switch (i.label) {
          case 0:
            return [4, this.resolveSessionId()];
          case 1:
            return e = i.sent(), this.context = g({ sessionId: e }, this.context), r = this, [4, this.storage.get(Q)];
          case 2:
            return r.toggles = i.sent() || [], o = this, [4, this.getLastRefreshTimestamp()];
          case 3:
            return o.lastRefreshTimestamp = i.sent(), !this.bootstrap || !this.bootstrapOverride && this.toggles.length !== 0 ? [3, 6] : [4, this.storage.save(Q, this.bootstrap)];
          case 4:
            return i.sent(), this.toggles = this.bootstrap, this.sdkState = "healthy", [4, this.storeLastRefreshTimestamp()];
          case 5:
            i.sent(), this.setReady(), i.label = 6;
          case 6:
            return this.sdkState = "healthy", this.emit(R.INIT), [2];
        }
      });
    });
  }, n.prototype.start = function() {
    return w(this, void 0, void 0, function() {
      var e, r = this;
      return x(this, function(o) {
        switch (o.label) {
          case 0:
            return this.started = !0, this.timerRef ? (console.error("Unleash SDK has already started, if you want to restart the SDK you should call client.stop() before starting again."), [2]) : [4, this.ready];
          case 1:
            return o.sent(), this.metrics.start(), e = this.refreshInterval, [4, this.initialFetchToggles()];
          case 2:
            return o.sent(), e > 0 && (this.timerRef = setInterval(function() {
              return r.fetchToggles();
            }, e)), [2];
        }
      });
    });
  }, n.prototype.stop = function() {
    this.timerRef && (clearInterval(this.timerRef), this.timerRef = void 0), this.metrics.stop();
  }, n.prototype.isReady = function() {
    return this.readyEventEmitted;
  }, n.prototype.getError = function() {
    return this.sdkState === "error" ? this.lastError : void 0;
  }, n.prototype.sendMetrics = function() {
    return this.metrics.sendMetrics();
  }, n.prototype.resolveSessionId = function() {
    return w(this, void 0, void 0, function() {
      var e;
      return x(this, function(r) {
        switch (r.label) {
          case 0:
            return this.context.sessionId ? [2, this.context.sessionId] : [4, this.storage.get("sessionId")];
          case 1:
            return (e = r.sent()) ? [3, 3] : (e = Math.floor(1e9 * Math.random()), [4, this.storage.save("sessionId", e.toString(10))]);
          case 2:
            r.sent(), r.label = 3;
          case 3:
            return [2, e.toString(10)];
        }
      });
    });
  }, n.prototype.getHeaders = function() {
    var e, r = this.usePOSTrequests, o = ((e = {})[this.headerName] = this.clientKey, e.Accept = "application/json", e["x-unleash-sdk"] = ve, e["x-unleash-connection-id"] = this.connectionId, e["x-unleash-appname"] = this.context.appName, e);
    return r && (o["Content-Type"] = "application/json"), this.etag && (o["If-None-Match"] = this.etag), Object.entries(this.customHeaders).filter(z).forEach(function(i) {
      var s = i[0], a = i[1];
      return o[s] = a;
    }), o;
  }, n.prototype.storeToggles = function(e) {
    return w(this, void 0, void 0, function() {
      return x(this, function(r) {
        switch (r.label) {
          case 0:
            return this.toggles = e, this.emit(R.UPDATE), [4, this.storage.save(Q, e)];
          case 1:
            return r.sent(), [2];
        }
      });
    });
  }, n.prototype.isTogglesStorageTTLEnabled = function() {
    var e;
    return !!(!((e = this.experimental) === null || e === void 0) && e.togglesStorageTTL && this.experimental.togglesStorageTTL > 0);
  }, n.prototype.isUpToDate = function() {
    var e;
    if (!this.isTogglesStorageTTLEnabled())
      return !1;
    var r = Date.now(), o = ((e = this.experimental) === null || e === void 0 ? void 0 : e.togglesStorageTTL) || 0;
    return this.lastRefreshTimestamp > 0 && this.lastRefreshTimestamp <= r && r - this.lastRefreshTimestamp <= o;
  }, n.prototype.getLastRefreshTimestamp = function() {
    return w(this, void 0, void 0, function() {
      var e, r;
      return x(this, function(o) {
        switch (o.label) {
          case 0:
            return this.isTogglesStorageTTLEnabled() ? [4, this.storage.get(le)] : [3, 3];
          case 1:
            return e = o.sent(), [4, ie(this.context)];
          case 2:
            return r = o.sent(), [2, (e == null ? void 0 : e.key) === r ? e.timestamp : 0];
          case 3:
            return [2, 0];
        }
      });
    });
  }, n.prototype.storeLastRefreshTimestamp = function() {
    return w(this, void 0, void 0, function() {
      var e, r;
      return x(this, function(o) {
        switch (o.label) {
          case 0:
            return this.isTogglesStorageTTLEnabled() ? (this.lastRefreshTimestamp = Date.now(), r = {}, [4, ie(this.context)]) : [3, 3];
          case 1:
            return r.key = o.sent(), r.timestamp = this.lastRefreshTimestamp, e = r, [4, this.storage.save(le, e)];
          case 2:
            o.sent(), o.label = 3;
          case 3:
            return [2];
        }
      });
    });
  }, n.prototype.initialFetchToggles = function() {
    if (!this.isUpToDate())
      return this.fetchToggles();
    this.fetchedFromServer || (this.fetchedFromServer = !0, this.setReady());
  }, n.prototype.fetchToggles = function() {
    return w(this, void 0, void 0, function() {
      var e, r, o, i, s, a, u, c, l;
      return x(this, function(v) {
        switch (v.label) {
          case 0:
            if (!this.fetch)
              return [3, 9];
            this.abortController && this.abortController.abort(), this.abortController = (l = this.createAbortController) === null || l === void 0 ? void 0 : l.call(this), e = this.abortController ? this.abortController.signal : void 0, v.label = 1;
          case 1:
            return v.trys.push([1, 7, 8, 9]), r = this.usePOSTrequests, o = r ? this.url : function(E, I) {
              var S = new URL(E.toString());
              return Object.entries(I).filter(z).forEach(function(h) {
                var p = h[0], m = h[1];
                p === "properties" && m ? Object.entries(m).filter(z).forEach(function(U) {
                  var O = U[0], j = U[1];
                  return S.searchParams.append("properties[".concat(O, "]"), j);
                }) : S.searchParams.append(p, m);
              }), S;
            }(this.url, this.context), i = r ? "POST" : "GET", s = r ? JSON.stringify({ context: this.context }) : void 0, [4, this.fetch(o.toString(), { method: i, cache: "no-cache", headers: this.getHeaders(), body: s, signal: e })];
          case 2:
            return a = v.sent(), this.sdkState === "error" && a.status < 400 && (this.sdkState = "healthy", this.emit(R.RECOVERED)), a.ok ? (this.etag = a.headers.get("ETag") || "", [4, a.json()]) : [3, 5];
          case 3:
            return u = v.sent(), [4, this.storeToggles(u.toggles)];
          case 4:
            return v.sent(), this.sdkState !== "healthy" && (this.sdkState = "healthy"), this.fetchedFromServer || (this.fetchedFromServer = !0, this.setReady()), this.storeLastRefreshTimestamp(), [3, 6];
          case 5:
            a.status === 304 ? this.storeLastRefreshTimestamp() : (console.error("Unleash: Fetching feature toggles did not have an ok response"), this.sdkState = "error", this.emit(R.ERROR, { type: "HttpError", code: a.status }), this.lastError = { type: "HttpError", code: a.status }), v.label = 6;
          case 6:
            return [3, 9];
          case 7:
            return typeof (c = v.sent()) == "object" && c !== null && "name" in c && c.name === "AbortError" || (console.error("Unleash: unable to fetch feature toggles", c), this.sdkState = "error", this.emit(R.ERROR, c), this.lastError = c), [3, 9];
          case 8:
            return this.abortController = null, [7];
          case 9:
            return [2];
        }
      });
    });
  }, n;
}(Ne);
const L = Symbol("Context state identifier"), We = Symbol("Context update identifier");
function $e({
  config: t,
  unleashClient: n,
  startClient: e = !0
}) {
  var r, o;
  const i = k(n), s = k(!1), a = k(null);
  !t && !n && console.warn(`You must provide either a config or an unleash client to the flag provider. If you are initializing the client in useEffect, you can avoid this warning by
    checking if the client exists before rendering.`), !i.value && t && (i.value = new ze(t)), (r = i.value) == null || r.on("ready", () => {
    s.value = !0;
  }), (o = i.value) == null || o.on("error", (h) => {
    a.value = h;
  });
  const E = Se({
    on: (h, ...p) => {
      var m;
      return (m = i.value) == null ? void 0 : m.on(h, ...p);
    },
    updateContext: async (h) => {
      var p;
      await ((p = i.value) == null ? void 0 : p.updateContext(h));
    },
    isEnabled: (h) => {
      var p;
      return (p = i.value) == null ? void 0 : p.isEnabled(h);
    },
    getVariant: (h) => {
      var p;
      return (p = i.value) == null ? void 0 : p.getVariant(h);
    },
    client: i,
    flagsReady: s,
    flagsError: a
  }), I = (h, p) => {
    E[h] = p;
  }, S = () => {
    var h;
    (e || !n) && ((h = i == null ? void 0 : i.value) == null || h.start());
  };
  return {
    context: we(E),
    update: I,
    start: S
  };
}
const Ye = (t) => {
  const { isEnabled: n, client: e } = H(L, {}), r = k(!!(n != null && n.value(t)));
  function o() {
    const s = n == null ? void 0 : n.value(t);
    s !== r.value && (r.value = !!s);
  }
  function i() {
    r.value = !!(n != null && n.value(t));
  }
  return e == null || e.value.on("ready", i), e == null || e.value.on("update", o), fe(() => {
    e == null || e.value.off("ready", i), e == null || e.value.off("update", o);
  }), r;
}, Ge = () => {
  const { flagsReady: t, flagsError: n } = H(L, {});
  return { flagsReady: t, flagsError: n };
}, Ve = (t, n) => {
  var e, r, o, i;
  return !((t == null ? void 0 : t.name) === (n == null ? void 0 : n.name) && (t == null ? void 0 : t.enabled) === (n == null ? void 0 : n.enabled) && (t == null ? void 0 : t.feature_enabled) === (n == null ? void 0 : n.feature_enabled) && ((e = t == null ? void 0 : t.payload) == null ? void 0 : e.type) === ((r = n == null ? void 0 : n.payload) == null ? void 0 : r.type) && ((o = t == null ? void 0 : t.payload) == null ? void 0 : o.value) === ((i = n == null ? void 0 : n.payload) == null ? void 0 : i.value));
}, Qe = (t) => {
  const { getVariant: n, client: e } = H(L, {}), r = k(n == null ? void 0 : n.value(t));
  function o() {
    const s = n == null ? void 0 : n.value(t);
    Ve(r == null ? void 0 : r.value, s) && (r.value = s);
  }
  function i() {
    r.value = n == null ? void 0 : n.value(t);
  }
  return e == null || e.value.on("ready", i), e == null || e.value.on("update", o), fe(() => {
    e == null || e.value.off("ready", i), e == null || e.value.off("update", o);
  }), r || {};
}, It = () => {
  const { updateContext: t } = H(L, {});
  return t == null ? void 0 : t.value;
}, Rt = () => {
  const { client: t } = H(L, {});
  return t == null ? void 0 : t.value;
}, Xe = {
  install(t, { config: n, unleashClient: e, startClient: r }) {
    const { context: o, update: i, start: s } = $e({
      config: n,
      unleashClient: e,
      startClient: r
    });
    t.provide(L, o), t.provide(We, i), s();
  }
};
function Ze(t) {
  return Re() ? (Oe(t), !0) : !1;
}
const et = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const tt = Object.prototype.toString, nt = (t) => tt.call(t) === "[object Object]", rt = () => {
};
function ot(...t) {
  if (t.length !== 1)
    return Te(...t);
  const n = t[0];
  return typeof n == "function" ? he(Ie(() => ({ get: n, set: rt }))) : k(n);
}
function it(t, n) {
  function e(...r) {
    return new Promise((o, i) => {
      Promise.resolve(t(() => n.apply(this, r), { fn: n, thisArg: this, args: r })).then(o).catch(i);
    });
  }
  return e;
}
const ge = (t) => t();
function st(t = ge, n = {}) {
  const {
    initialState: e = "active"
  } = n, r = ot(e === "active");
  function o() {
    r.value = !1;
  }
  function i() {
    r.value = !0;
  }
  const s = (...a) => {
    r.value && t(...a);
  };
  return { isActive: he(r), pause: o, resume: i, eventFilter: s };
}
function X(t) {
  return Array.isArray(t) ? t : [t];
}
function at(t) {
  return Ee();
}
function lt(t, n, e = {}) {
  const {
    eventFilter: r = ge,
    ...o
  } = e;
  return Y(
    t,
    it(
      r,
      n
    ),
    o
  );
}
function ut(t, n, e = {}) {
  const {
    eventFilter: r,
    initialState: o = "active",
    ...i
  } = e, { eventFilter: s, pause: a, resume: u, isActive: c } = st(r, { initialState: o });
  return { stop: lt(
    t,
    n,
    {
      ...i,
      eventFilter: s
    }
  ), pause: a, resume: u, isActive: c };
}
function ct(t, n = !0, e) {
  at() ? xe(t, e) : n ? t() : de(t);
}
function ft(t, n, e) {
  return Y(
    t,
    n,
    {
      ...e,
      immediate: !0
    }
  );
}
const $ = et ? window : void 0;
function dt(t) {
  var n;
  const e = A(t);
  return (n = e == null ? void 0 : e.$el) != null ? n : e;
}
function ue(...t) {
  const n = [], e = () => {
    n.forEach((a) => a()), n.length = 0;
  }, r = (a, u, c, l) => (a.addEventListener(u, c, l), () => a.removeEventListener(u, c, l)), o = W(() => {
    const a = X(A(t[0])).filter((u) => u != null);
    return a.every((u) => typeof u != "string") ? a : void 0;
  }), i = ft(
    () => {
      var a, u;
      return [
        (u = (a = o.value) == null ? void 0 : a.map((c) => dt(c))) != null ? u : [$].filter((c) => c != null),
        X(A(o.value ? t[1] : t[0])),
        X(Z(o.value ? t[2] : t[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        A(o.value ? t[3] : t[2])
      ];
    },
    ([a, u, c, l]) => {
      if (e(), !(a != null && a.length) || !(u != null && u.length) || !(c != null && c.length))
        return;
      const v = nt(l) ? { ...l } : l;
      n.push(
        ...a.flatMap(
          (E) => u.flatMap(
            (I) => c.map((S) => r(E, I, S, v))
          )
        )
      );
    },
    { flush: "post" }
  ), s = () => {
    i(), e();
  };
  return Ze(e), s;
}
const q = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, B = "__vueuse_ssr_handlers__", ht = /* @__PURE__ */ pt();
function pt() {
  return B in q || (q[B] = q[B] || {}), q[B];
}
function vt(t, n) {
  return ht[t] || n;
}
function gt(t) {
  return t == null ? "any" : t instanceof Set ? "set" : t instanceof Map ? "map" : t instanceof Date ? "date" : typeof t == "boolean" ? "boolean" : typeof t == "string" ? "string" : typeof t == "object" ? "object" : Number.isNaN(t) ? "any" : "number";
}
const yt = {
  boolean: {
    read: (t) => t === "true",
    write: (t) => String(t)
  },
  object: {
    read: (t) => JSON.parse(t),
    write: (t) => JSON.stringify(t)
  },
  number: {
    read: (t) => Number.parseFloat(t),
    write: (t) => String(t)
  },
  any: {
    read: (t) => t,
    write: (t) => String(t)
  },
  string: {
    read: (t) => t,
    write: (t) => String(t)
  },
  map: {
    read: (t) => new Map(JSON.parse(t)),
    write: (t) => JSON.stringify(Array.from(t.entries()))
  },
  set: {
    read: (t) => new Set(JSON.parse(t)),
    write: (t) => JSON.stringify(Array.from(t))
  },
  date: {
    read: (t) => new Date(t),
    write: (t) => t.toISOString()
  }
}, ce = "vueuse-storage";
function mt(t, n, e, r = {}) {
  var o;
  const {
    flush: i = "pre",
    deep: s = !0,
    listenToStorageChanges: a = !0,
    writeDefaults: u = !0,
    mergeDefaults: c = !1,
    shallow: l,
    window: v = $,
    eventFilter: E,
    onError: I = (d) => {
      console.error(d);
    },
    initOnMounted: S
  } = r, h = (l ? ke : k)(typeof n == "function" ? n() : n), p = W(() => A(t));
  if (!e)
    try {
      e = vt("getDefaultStorage", () => {
        var d;
        return (d = $) == null ? void 0 : d.localStorage;
      })();
    } catch (d) {
      I(d);
    }
  if (!e)
    return h;
  const m = A(n), U = gt(m), O = (o = r.serializer) != null ? o : yt[U], { pause: j, resume: D } = ut(
    h,
    () => J(h.value),
    { flush: i, deep: s, eventFilter: E }
  );
  Y(p, () => C(), { flush: i }), v && a && ct(() => {
    e instanceof Storage ? ue(v, "storage", C, { passive: !0 }) : ue(v, ce, G), S && C();
  }), S || C();
  function M(d, y) {
    if (v) {
      const T = {
        key: p.value,
        oldValue: d,
        newValue: y,
        storageArea: e
      };
      v.dispatchEvent(e instanceof Storage ? new StorageEvent("storage", T) : new CustomEvent(ce, {
        detail: T
      }));
    }
  }
  function J(d) {
    try {
      const y = e.getItem(p.value);
      if (d == null)
        M(y, null), e.removeItem(p.value);
      else {
        const T = O.write(d);
        y !== T && (e.setItem(p.value, T), M(y, T));
      }
    } catch (y) {
      I(y);
    }
  }
  function N(d) {
    const y = d ? d.newValue : e.getItem(p.value);
    if (y == null)
      return u && m != null && e.setItem(p.value, O.write(m)), m;
    if (!d && c) {
      const T = O.read(y);
      return typeof c == "function" ? c(T, m) : U === "object" && !Array.isArray(T) ? { ...m, ...T } : T;
    } else return typeof y != "string" ? y : O.read(y);
  }
  function C(d) {
    if (!(d && d.storageArea !== e)) {
      if (d && d.key == null) {
        h.value = m;
        return;
      }
      if (!(d && d.key !== p.value)) {
        j();
        try {
          (d == null ? void 0 : d.newValue) !== O.write(h.value) && (h.value = N(d));
        } catch (y) {
          I(y);
        } finally {
          d ? de(D) : D();
        }
      }
    }
  }
  function G(d) {
    C(d.detail);
  }
  return h;
}
function bt(t, n, e = {}) {
  const { window: r = $ } = e;
  return mt(t, n, r == null ? void 0 : r.localStorage, e);
}
const St = "@loadsmart/vue-feature-flags", wt = {
  name: St
}, xt = `${wt.name}:overrides`;
function ye(t) {
  const n = k({ enabled: !1, ready: !1, error: !1 }), e = Ye(t), { flagsReady: r, flagsError: o } = Ge(), i = bt(
    xt,
    {},
    { writeDefaults: !0 }
  );
  return Y(
    [e, r, o, i],
    () => {
      const s = A(e) ?? !1;
      n.value.enabled = i.value[t] ?? s, n.value.ready = A(r) ?? !1, n.value.error = A(o) ?? !1;
    },
    { immediate: !0 }
  ), n;
}
const Et = /* @__PURE__ */ Ae({
  __name: "FeatureFlag",
  props: { name: { type: String, required: !0 } },
  setup(t) {
    const e = ye(t.name);
    return (r, o) => Z(e).ready ? Z(e).enabled ? V(r.$slots, "enabled", { key: 1 }) : V(r.$slots, "disabled", { key: 2 }) : V(r.$slots, "not-ready", { key: 0 });
  }
}), Ot = {
  install(t, n) {
    Xe.install(t, n), t.component("FeatureFlag", Et);
  }
};
function kt(t) {
  const n = k(!1), e = ye(t), r = Qe(t), o = W(() => n.value || e.value.error);
  return { value: W(() => {
    const s = r.value ? r.value.payload : null;
    if (!s || !e.value.enabled || o.value) return null;
    const { type: a, value: u } = s;
    if (a !== "json") return u;
    try {
      return n.value = !1, JSON.parse(u);
    } catch {
      return n.value = !0, null;
    }
  }), error: o };
}
export {
  Et as FeatureFlag,
  Ot as plugin,
  Rt as useClient,
  It as useContext,
  ye as useFlag,
  kt as useVariant
};
